import React from "react"
import { Alert, Button, Card, Col, Container, Form, Row } from "react-bootstrap"
import "bootstrap/dist/css/bootstrap.min.css"
import Cookies from "universal-cookie"
import { auth, pylog } from "../../api/api_auth"
import withHooks from "./WithHooks"
import { pyLog } from "../js/pyLog"

class Login extends React.Component {
  constructor(props) {
    super(props)

    this.dMgr = this.props.DebugManager(this.constructor.name)
    // this.dMgr.activate(true)
    this.dMgr.debug("const_props:", this.props)

    this.state = {
      isReadyToRender: false,
      email: "",
      password: "",
      pylog: this.props.pylog !== undefined ? this.props.pylog : "",
      errorMessage: "",
    }

    this.dMgr.debug("init_state:", this.state)

    this.login = this.login.bind(this)
    this.handleEmailChange = this.handleEmailChange.bind(this)
    this.handlePasswordChange = this.handlePasswordChange.bind(this)

    this.cookies = new Cookies()
    this.loginFromCookie = this.loginFromCookie.bind(this)
    this.isValidCookie = this.isValidCookie.bind(this)
    this.loginsuccess = this.loginsuccess.bind(this)
  }

  componentDidMount() {
    if (!this.isValidCookie() && this.props.autoPyLog) {
      const pylog = pyLog()
      this.dMgr.debug("call autopylog", pylog)
      this.setState({ pylog: pylog }, this.pylog)
    } else if (this.state.pylog !== "") {
      this.pylog()
    } else {
      this.loginFromCookie()
      this.setState({ isReadyToRender: true })
    }
  }

  isValidCookie() {
    if (this.cookies.get("gg_token") !== undefined && this.cookies.get("gg_refresh_token") !== undefined && this.cookies.get("gg_user") !== undefined) {
      return true
    } else {
      return false
    }
  }

  loginFromCookie() {
    if (this.isValidCookie()) {
      this.dMgr.debug("loginFromCookie:", "cookie ok")

      // console.log("cookie ok");
      // console.log("cookie gg_token", this.cookies.get("gg_token"));
      // console.log("cookie gg_user", this.cookies.get("gg_user"));
      // console.log("cookie gg_refresh_token", this.cookies.get("gg_refresh_token"));

      this.props.loggedInHandler()
    } else {
      this.dMgr.debug("loginFromCookie:", "cookie empty")

      // console.log("cookie empty")
      // console.log("cookie gg_token", this.cookies.get("gg_token"));
      // console.log("cookie gg_user", this.cookies.get("gg_user"));
      // console.log("cookie gg_refresh_token", this.cookies.get("gg_refresh_token"));
    }
  }

  handleEmailChange(event) {
    this.setState({ email: event.target.value })
  }

  handlePasswordChange(event) {
    this.setState({ password: event.target.value })
  }

  login(e) {
    e.preventDefault()

    Promise.all([auth(this.state.email, this.state.password)]).then((promisesResults) => {
      const [response] = promisesResults

      // console.log("auth", response)

      if (response.token !== undefined) {
        this.loginsuccess(response)
      } else {
        this.setState({ errorMessage: this.props.t("message.accessDenied") })
        setTimeout(() => this.setState({ errorMessage: "" }), 3000)
      }
    })
  }

  pylog() {
    this.dMgr.debug("pylog", this.state.pylog)
    Promise.all([pylog(this.state.pylog)]).then((promisesResults) => {
      const [response] = promisesResults

      this.dMgr.debug("pylog response", response)

      if (response.token !== undefined) {
        this.loginsuccess(response)
      } else {
        this.setState({ errorMessage: this.props.t("message.accessDenied") })
        setTimeout(() => this.setState({ errorMessage: "" }), 3000)
      }
    })
  }

  loginsuccess(response) {
    this.cookies.set("gg_token", response.token, { path: "/" })
    this.cookies.set("gg_user", response.user, { path: "/" })
    this.cookies.set("gg_refresh_token", response.refresh_token, { path: "/" })

    const serverTime = new Date(response.serverTime).getTime()
    const localTime = Date.now()
    const timeOffset = serverTime - localTime
    this.cookies.set("gg_time_offset", timeOffset)

    // console.log("auth success", this.cookies)

    this.props.loggedInHandler()
  }

  render() {
    if (!this.state.isReadyToRender) {
      this.dMgr.debug("render:", "not ready")
      return null
    }

    if (this.state.pylog !== "") {
      this.dMgr.debug("PYLOG:", this.state.pylog)
      return ""
    }

    this.dMgr.rendering()

    let errorAlert = ""
    if (this.state.errorMessage !== "") {
      errorAlert = (
        <Alert variant="danger" className="text-center">
          {this.state.errorMessage}
        </Alert>
      )
    }

    let toRender = (
      <Container>
        <Row className="justify-content-md-center">
          <Col id="login-col" md="auto">
            <Form noValidate>
              <Card className="bg-dark text-white box-shadow-lvl3" style={{ width: "20rem" }}>
                <Card.Header as="h4" className="text-center margin-top-8">
                  <img src="/favicon.png" className="app-logo" alt="" />
                  Green Garden
                </Card.Header>
                <Card.Body>
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>{this.props.t("form.email")}</Form.Label>
                    <Form.Control type="email" value={this.state.email} onChange={this.handleEmailChange} />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formBasicPassword">
                    <Form.Label>{this.props.t("form.password")}</Form.Label>
                    <Form.Control type="password" value={this.state.password} onChange={this.handlePasswordChange} />
                    {/* <a href="/forgot_password">{this.props.t("app.passwordForgot")}</a> */}
                  </Form.Group>

                  <Form.Group className="mb-3">{errorAlert}</Form.Group>

                  <br />
                  <Form.Group className="text-center" controlId="formBasicPassword">
                    <Button variant="primary" type="submit" onClick={this.login}>
                      {this.props.t("action.logIn")}
                    </Button>
                  </Form.Group>
                </Card.Body>
              </Card>
            </Form>
          </Col>
        </Row>
      </Container>
    )

    this.dMgr.renderDone()
    return toRender
  }
}
export default withHooks(Login)
